import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  initializeModule,
  integrationsFetched,
  organizationPairingIntegrationLoaded
} from '../actions/integrations.actions';
import { IntegrationsApiService } from '../services/integrations-api.service';
import { IntegrationType } from 'common/store/genesys-cloud/integrations/models/integration-type.enum';
import { GenesysUserPermissionService } from 'common/store/genesys-cloud/users/services/user-permission.service';
import { UserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudIntegrationsEffects {
  readonly loadIntegrations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initializeModule),
      mergeMap(() => this.permissionService.hasPermission$(UserPermission.IntegrationsIntegrationView)),
      mergeMap((permission) => this._getIntegrations$(permission)),
      catchError((err: any, _) => {
        console.error('Error during fetching integrations', err);
        return of(integrationsFetched({ integrations: [] }));
      })
    )
  );

  readonly pairingIntegration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(integrationsFetched),
      map(({ integrations }) =>
        integrations.find((integration) => integration.integrationType.id === IntegrationType.OrgPairingIntegrationType)
      ),
      map((orgPairingIntegration) => organizationPairingIntegrationLoaded({ orgPairingIntegration }))
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly api: IntegrationsApiService,
    private readonly permissionService: GenesysUserPermissionService
  ) {}

  private _getIntegrations$(hasPermission: boolean): Observable<Action> {
    if (hasPermission) {
      return this.api
        .getIntegrations$()
        .pipe(map((integrations) => integrationsFetched({ integrations: integrations.entities })));
    } else {
      return of(integrationsFetched({ integrations: [] }));
    }
  }
}
